import * as Cesium from "cesium";
import React, { useEffect } from "react";

type Entity = Cesium.Entity | Cesium.Entity.ConstructorOptions;

export default function usePanoramaEntities({
  viewer,
}: {
  viewer: Cesium.Viewer | undefined | null;
}) {
  const [entities, setEntities] = React.useState<Entity[]>([]);

  useEffect(() => {
    if (!viewer || !entities.length) {
      return;
    }

    entities.forEach((entity) => {
      viewer.entities.add(entity);
    });

    // eslint-disable-next-line consistent-return
    return () => {
      entities.forEach((entity) => {
        if (entity.id) viewer.entities.removeById(entity.id);
      });
      viewer.scene.postProcessStages.removeAll();
      viewer.screenSpaceEventHandler.removeInputAction(
        Cesium.ScreenSpaceEventType.LEFT_CLICK,
      );
    };
  }, [viewer, entities]);

  const [pinClickHandler, setFinClickHandler] =
    React.useState<Cesium.ScreenSpaceEventHandler | null>(null);

  React.useEffect(() => {
    if (!viewer) {
      return;
    }
    setFinClickHandler(new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas));

    // eslint-disable-next-line consistent-return
    return () => {
      setFinClickHandler(null);
    };
  }, [setFinClickHandler, viewer]);

  return { pinClickHandler, setEntities };
}
